(function () {
    'use strict';

    angular
        .module('app.campaignAdvertiserManagePageAddInfluencers')
        .factory('campaignAdvertiserManagePageAddInfluencersService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

               function handleRequest(url, method, params, loader) {
                  var deferred = $q.defer();

                  var req = {
                     url: url,
                     method: method,
                     data: JSON.stringify(params),
                     loader: loader
                  } 

                  $http(req)
                     .success(function (data) {
                     var dataRes = angular.fromJson(data);

                     if (checkResponse(dataRes)) {
                         deferred.resolve(dataRes);
                     } else {
                         deferred.reject(getMessage(dataRes));
                     }
                  })
                     .error(function (error) {
                         deferred.reject(error);
                     });

                  return deferred.promise;
               }

                function searchInfluencerForCampaign(text, loader) {
                    var url_searchInfluencerForCampaign = $rootScope.apiUrl + 'campaign/searchInfluencerForCampaign?searchString=' + text;
                    return handleRequest(url_searchInfluencerForCampaign, 'GET', null, loader);
                }

                function saveInfluencerToCampaign(saveInfluencerToCampaignData, loader) {
                    var saveInfluencerToCampaignUrl = $rootScope.apiUrl + 'campaign/addInfluencersToOneCampaign';
                    return handleRequest(saveInfluencerToCampaignUrl, 'POST', saveInfluencerToCampaignData, loader);
                }

                service.searchInfluencerForCampaign = searchInfluencerForCampaign;
                service.saveInfluencerToCampaign = saveInfluencerToCampaign;

                return service;
            }
        ]);
})();
